import Vue from "vue";
import Vuex from "vuex";
import redirectInterceptor from "@/interceptors/redirect_interceptor";
import router from "@/router";
import { weatherRoutingModule } from "./modules/weather_routing/index.js";
import { sensorIssuesModule } from "./modules/vessel_information/sensor_issues.js";
import { weatherDataModule } from "./modules/vessel_information/weather_data.js";
import { alertsModule } from "./modules/alerts/alert.js";
import { fleetAlertsModule } from "./modules/alerts/fleet.js";
import { notificationsModule } from "./modules/notifications/index.js";
import { kdiagramCalculateModule } from "./modules/kdiagram/index.js";
import { vesselInformationModule } from "./modules/vessel_information/index.js";
import { windGlobalModule } from "./modules/vessel_information/windGlobalModule";
import { weatherRelativeWindDataModule } from "./modules/vessel_information/provider_relative_wind";
import { ciiModule } from "./modules/cii/index.js";
import { mainModule } from "./modules/main/index.js";
import { fleetModule } from "@/modules/home2/fleet.js";
import signals from "@/modules/data_overview/signals";
import axios from "axios";
import { getConfig } from "@/config";
import alarms from "@/modules/data_overview/alarms";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

    //login
    loginError: null,
    quad_token: null,
    role: null,
    userId: null,
    //menu
    fleets: null,
    groupsMenu: null,
    VesselsData: null,
    highlightControl: null,
    sideBar: false,

    //vessels
    vesselAllVoyageLegs: [],
    vesselRangeDates: {},
    currentVesselId: "",
    currentVesselName: "",
    currentLeg: {},
    currentEvent: {},
    compare: [],
    groupVessels: [],
    VesselKPI: null,
    VesselKPILoading: true,
    VesselKStatic: null,
    VesselKDynamic: null,
    VesselKDynamicLoading: null,
    VesselFouling: null,
    VesselFoulingLoading: true,
    VesselFoulingCons: null,
    VesselFoulingConsLoading: true,
    VesselPorts: null,
    VesselPortsLoading: true,
    VesselMeasurementErrors: null,
    VesselMeasurementErrorsLoading: true,
    VesselMeasurementErrorsAggr: null,
    VesselMeasurementErrorsAggrLoading: true,
    VesselMissingRecords: null,
    VesselMissingRecordsLoading: true,
    showLoader: false,
    ComparisonPower: null,
    SisterComparison: [],
    FoulingLocations: [],

    ComparisonDates: [],
    ComparisonFDMData: [],
    VoyageCleanData: null,
    VoyageFuels: null,
    VoyageAuxRHP: null,
    VoyageInfo: null,
    FoulingVideo: null,

    MapLimits: null,

    CiiAverage: [],
    CiiHistorical: [],
    CiiContributionValues: JSON.parse(localStorage.getItem("ciiContributionValues")) || [],
    CiiRatings: {},

  },
  mutations: {

    setBasicUrl: (state, basicUrl) => (state.basicUrl = basicUrl),
    setWSUrl: (state, wsUrl) => (state.wsUrl = wsUrl),
    //login
    updateAccessToken: (state, quad_token) => { state.quad_token = quad_token; },
    updateRole: (state, role) => { state.role = role; },
    updateId: (state, userId) => { state.userId = userId; },
    logout: (state) => {
      state.quad_token = null;
      state.role = null;
      state.userId = null;
    },
    //menu
    setHighlightControl: (state, f) => { state.highlightControl = f; },
    setSideBar: (state, f) => { state.sideBar = f; },
    setVesselsData: (state, f) => { state.VesselsData = f; },

    //vessels
    setVesselAllVoyageLegs: (state, vesselAllVoyageLegs) => (state.vesselAllVoyageLegs = vesselAllVoyageLegs),
    setVesselRangeDates: (state, vesselRangeDates) => (state.vesselRangeDates = vesselRangeDates),
    setVesselKStatic: (state, VesselKStatic) => (state.VesselKStatic = VesselKStatic),
    setVesselFouling: (state, VesselFouling) => (state.VesselFouling = VesselFouling),
    setVesselFoulingLoading: (state, VesselFoulingLoading) => (state.VesselFoulingLoading = VesselFoulingLoading),
    setVesselFoulingCons: (state, VesselFoulingCons) => (state.VesselFoulingCons = VesselFoulingCons),
    setVesselFoulingConsLoading: (state, VesselFoulingConsLoading) => (state.VesselFoulingConsLoading = VesselFoulingConsLoading),
    setVesselMeasurementErrors: (state, VesselMeasurementErrors) => (state.VesselMeasurementErrors = VesselMeasurementErrors),
    setVesselMeasurementErrorsLoading: (state, VesselMeasurementErrorsLoading) => (state.VesselMeasurementErrorsLoading = VesselMeasurementErrorsLoading),
    setVesselMeasurementErrorsAggr: (state, VesselMeasurementErrorsAggr) => (state.VesselMeasurementErrorsAggr = VesselMeasurementErrorsAggr),
    setVesselMeasurementErrorsAggrLoading: (state, VesselMeasurementErrorsAggrLoading) => (state.VesselMeasurementErrorsAggrLoading = VesselMeasurementErrorsAggrLoading),
    setVesselMissingRecords: (state, VesselMissingRecords) => (state.VesselMissingRecords = VesselMissingRecords),
    setVesselMissingRecordsLoading: (state, VesselMissingRecordsLoading) => (state.VesselMissingRecordsLoading = VesselMissingRecordsLoading),
    setVoyageAuxRHP: (state, VoyageAuxRHP) => (state.VoyageAuxRHP = VoyageAuxRHP),
    setCurrentVesselName: (state, name) => (state.currentVesselName = name),
    setCurrentEvent: (state, event) => (state.currentEvent = event),
    setVoyageInfo: (state, VoyageInfo) => (state.VoyageInfo = VoyageInfo),
    setMapLimits: (state, data) => { state.MapLimits = data; },
    setComparisonPower: (state, ComparisonPower) => (state.ComparisonPower = ComparisonPower),
    setSisterComparison: (state, SisterComparison) => (state.SisterComparison = SisterComparison),
    setFoulingLocations: (state, FoulingLocations) => (state.FoulingLocations = FoulingLocations),
    setComparisonDates: (state, payload) => { state.ComparisonDates = Array.isArray(payload) ? payload : []; },

    setVoyageCleanData: (state, VoyageCleanData) => (state.VoyageCleanData = VoyageCleanData),
    setVoyageFuels: (state, VoyageFuels) => (state.VoyageFuels = VoyageFuels),

    setCiiAverage: (state, CiiAverage) => (state.CiiAverage = CiiAverage),
    setCiiHistorical: (state, CiiHistorical) => (state.CiiHistorical = CiiHistorical),
    setCiiRatings: (state, CiiRatings) => (state.CiiRatings = CiiRatings),

  },
  getters: {

    vessels: (state) => state.vessels,
    isLoading: (state) => state.loading,
    error: (state) => state.error,

    getBasicUrl: (state) => state.basicUrl,
    getWSUrl: (state) => state.wsUrl,
    getVesselsData: (state) => state.VesselsData,
    getHighlightControl: (state) => state.highlightControl,
    getSideBar: (state) => state.sideBar,
    //vessels
    getCurrentVesselName: (state) => state.currentVesselName,
    getCurrentVesselId: (state) => state.currentVesselId,
    getCurrentLeg: (state) => state.currentLeg,
    getCurrentEvent: (state) => state.currentEvent,
    getVesselAllVoyageLegs: (state) => state.vesselAllVoyageLegs,
    getVesselRangeDates: (state) => state.vesselRangeDates,
    getVesselKPI: (state) => state.VesselKPI,
    getVoyageAuxRHP: (state) => state.VoyageAuxRHP,
    getVesselKStatic: (state) => state.VesselKStatic,
    getVesselKDynamic: (state) => state.VesselKDynamic,
    getVesselKDynamicLoading: (state) => state.VesselKDynamicLoading,
    getVesselFouling: (state) => state.VesselFouling,
    getVesselFoulingLoading: (state) => state.VesselFoulingLoading,
    getVesselFoulingCons: (state) => state.VesselFoulingCons,
    getVesselMeasurementErrors: (state) => state.VesselMeasurementErrors,
    getVesselMeasurementErrorsAggr: (state) => state.VesselMeasurementErrorsAggr,
    getVesselMissingRecords: (state) => state.VesselMissingRecords,
    getComparisonPower: (state) => state.ComparisonPower,
    getVesselKProfiles: (state) => state.VesselKProfiles,
    getSisterComparison: (state) => state.SisterComparison,
    getFoulingLocations: (state) => state.FoulingLocations,
    getComparisonDates: (state) => state.ComparisonDates,
    getComparisonFDMData: (state) => state.ComparisonFDMData,

    getVoyageCleanData: (state) => state.VoyageCleanData,
    getVoyageFuels: (state) => state.VoyageFuels,
    getVoyageInfo: (state) => state.VoyageInfo,

    getMapLimits: (state) => state.MapLimits,

    getCiiAverage: (state) => state.CiiAverage,
    getCiiHistorical: (state) => state.CiiHistorical,
    getCiiContributionValues: (state) => state.CiiContributionValues,
    getCiiRatings: (state) => state.CiiRatings,

  },
  actions: {

    fetchApiUrls({ commit }, config) {

      commit("setBasicUrl", config.basicUrl);
      commit("setWSUrl", config.wsUrl);
      localStorage.setItem("basicUrl", config.basicUrl);
      localStorage.setItem("wsUrl", config.wsUrl);
    },
    logout({ commit }) {
      localStorage.removeItem("quad_token");
      localStorage.removeItem("role");
      localStorage.removeItem("userId");
      commit("logout");
      router.push("/login");
    },
    setHighlightControl({ commit }, controlId) {
      commit("setHighlightControl", controlId);
    },

    async fetchVesselsData({ commit }) {
      const basicUrl = getConfig().VUE_APP_BASIC_URL;
      const response = await axios.get(basicUrl + "/vesselperformance/fleet", {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      if (response.data.success) {
        commit("setVesselsData", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselsData", null);
      }

    },

    async fetchCiiRatings({ commit, state }, data) {
      const url = state.basicUrl + "/vesselperformance/vessel/" + data.vessel + "/cii/ratings/" + data.year;

      const response = await redirectInterceptor.get(url, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });

      if (response.data.success) {
        commit("setCiiRatings", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setCiiRatings", {});
      }
    },

    async fetchVesselAllVoyageLegs({ commit, state }, name) {

      const url = state.basicUrl + "/vesselperformance/vessel/" + name + "/allVoyageLegs/";

      const response = await redirectInterceptor.get(url, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });

      if (response.data.success) {
        commit("setVesselAllVoyageLegs", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselAllVoyageLegs", []);
      }
    },

    async fetchVesselRangeDates({ commit, state }, name) {

      const url = state.basicUrl + "/vesselperformance/vessel/" + name + "/rangeDates/";

      const response = await redirectInterceptor.get(url, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });

      if (response.data.success) {
        commit("setVesselRangeDates", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselRangeDates", {});
      }
    },
    async fetchVesselFouling({ commit, state }, name) {

      commit("setVesselFoulingLoading", true);
      commit("setVesselFouling", null);
      const response = await redirectInterceptor.get(state.basicUrl + "/vesselperformance/vessel/" + name + "/fouling", {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });

      if (response.data.success) {
        commit("setVesselFouling", response.data.data);
        commit("setVesselFoulingLoading", false);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselFouling", null);
        commit("setVesselFoulingLoading", false);
      }
    },
    async fetchVesselFoulingCons({ commit, state }, name) {
      commit("setVesselFoulingConsLoading", true);
      const response = await redirectInterceptor.get(state.basicUrl + "/vesselperformance/vessel/" + name + "/foulingconsumption", {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      if (response.data.success) {
        commit("setVesselFoulingCons", response.data.data);
        commit("setVesselFoulingConsLoading", false);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselFoulingCons", null);
        commit("setVesselFoulingConsLoading", false);
      }
    },
    async fetchVesselMeasurementErrors({ commit, state }, name) {
      commit("setVesselMeasurementErrorsLoading", true);
      const response = await redirectInterceptor.get(state.basicUrl + "/vesselperformance/vessel/" + name + "/measurementerrors", {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      if (response.data.success) {
        commit("setVesselMeasurementErrors", response.data.data);
        commit("setVesselMeasurementErrorsLoading", false);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselMeasurementErrors", null);
        commit("setVesselMeasurementErrorsLoading", false);
      }
    },
    async fetchVesselMeasurementErrorsAggr({ commit, state }, { name, days }) {
      commit("setVesselMeasurementErrorsAggrLoading", true);
      const response = await redirectInterceptor.get(state.basicUrl + "/vesselperformance/vessel/" + name + "/measurementerrorsdashboard/" + days, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      if (response.data.success) {
        commit("setVesselMeasurementErrorsAggr", response.data.data);
        commit("setVesselMeasurementErrorsAggrLoading", false);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselMeasurementErrorsAggr", false);
        commit("setVesselMeasurementErrorsAggrLoading", false);
      }
    },
    async fetchVesselMissingRecords({ commit, state }, { name, days }) {
      commit("setVesselMissingRecordsLoading", true);
      const response = await redirectInterceptor.get(state.basicUrl + "/vesselperformance/vessel/" + name + "/missingrecords/" + days, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      if (response.data.success) {
        commit("setVesselMissingRecords", response.data.data);
        commit("setVesselMissingRecordsLoading", false);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVesselMissingRecords", false);
        commit("setVesselMissingRecordsLoading", false);
      }
    },
    async fetchVoyageInfo({ commit, state }, data) {
      let url;

      if ("voyId" in data) url = state.basicUrl + "/vesselperformance/voyage/" + data.voyId + "/voyageinfo/";
      else url = state.basicUrl + "/vesselperformance/vessel/" + data.name + "/voyageinfo/" + data.startDate + "/" + data.stopDate;

      const response = await redirectInterceptor.get(url, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      commit("setVoyageInfo", "");

      if (response.data.success) {
        commit("setVoyageInfo", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVoyageInfo", false);
      }
    },
    async fetchVoyageAuxRHP({ commit, state }, data) {

      let url;

      if ("voyId" in data) url = state.basicUrl + "/vesselperformance/voyage/" + data.voyId + "/voyageAuxRHP/";
      else url = state.basicUrl + "/vesselperformance/vessel/" + data.name + "/voyageAuxRHP/" + data.startDate + "/" + data.stopDate;

      const response = await redirectInterceptor.get(url, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      if (response.data.success) {
        commit("setVoyageAuxRHP", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVoyageAuxRHP", null);

      }
    },
    async fetchComparisonPower({ commit, state }, postData) {

      try {
        const response = await redirectInterceptor.post(
          state.basicUrl + "/vesselperformance/vessel/" + postData.vessel + "/powercomp",
          { ...postData },
          {
            headers: {
              Authorization: localStorage.getItem("quad_token")
            }
          }
        );

        if (response.data.success) {
          const parsed = JSON.parse(response.data.data);
          commit("setComparisonPower", parsed);
          return parsed;
        } else {
          if (response.data.msg === "rdr") {
            router.push("/login").catch(function () { });
          }
          commit("setComparisonPower", null);
          return null;
        }

      } catch (e) {
        commit("setComparisonPower", null);
        return null;
      }
    },

    async fetchSisterComparison({ commit, state }, data) {
      let response;

      if ("voyId" in data)
        response = await redirectInterceptor.get(state.basicUrl + "/vesselperformance/voyage/" + data.voyId + "/voyageLocations", {
          headers: {
            Authorization: localStorage.getItem("quad_token")
          }
        });
      else {
        const vessels = { vessels: data.postData };

        response =
          await redirectInterceptor.post(state.basicUrl + "/vesselperformance/vessel/" + data.vessel + "/sistercomparisonLocations", { ...vessels }, {
            headers: {
              Authorization: localStorage.getItem("quad_token")
            }
          });
      }

      if (response.data.success) {
        commit("setSisterComparison", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setSisterComparison", []);
      }
    },

    async fetchFoulingLocations({ commit, state }, { vessel: vessel, postData: postData }) {
      const response = await redirectInterceptor.post(state.basicUrl + "/vesselperformance/vessel/" + vessel + "/foulingLocations", { ...postData }, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      if (response.data.success) {
        commit("setFoulingLocations", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setFoulingLocations", []);
      }
    },

    async fetchComparisonDates({ commit, state }, vessel) {
      try {
        const response = await redirectInterceptor.get(
          state.basicUrl + "/vesselperformance/vessel/" + vessel + "/comparisondates",
          {
            headers: { Authorization: localStorage.getItem("quad_token") }
          }
        );

        if (response.data && response.data.success) {
          const data = Array.isArray(response.data.data) ? response.data.data : [];
          commit("setComparisonDates", data);
          return data;
        }

        if (response.data && response.data.msg === "rdr") {
          router.push("/login").catch(() => { });
        }

        commit("setComparisonDates", []);
        return null;
      } catch (e) {
        commit("setComparisonDates", []);
        return null;
      }
    },

    async fetchComparisonFDMData({ state }, postData) {
      try {
        const response = await redirectInterceptor.post(
          state.basicUrl + "/vesselperformance/vessel/" + postData.vessel + "/comparisonfdm",
          { ...postData },
          {
            headers: {
              Authorization: localStorage.getItem("quad_token")
            }
          }
        );

        if (response.data.success) {
          return response.data.data;
        }

        return null;

      } catch (e) {
        return null;
      }
    },

    async fetchVoyageCleanData({ commit, state }, { vessId, startDate, stopDate, isCurrent }) {

      const response = await redirectInterceptor.get(state.basicUrl + "/vesselperformance/vessel/"
        + vessId + "/voyageCleanData/" + startDate + "/" + stopDate + "/" + isCurrent, {
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });

      if (response.data.success) {
        commit("setVoyageCleanData", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch((_err) => { });
        }
        commit("setVoyageCleanData", null);
      }

    },

  },
  modules: {
    main: mainModule,
    weatherRouting: weatherRoutingModule,
    sensorIssues: sensorIssuesModule,
    weatherData: weatherDataModule,
    alerts: alertsModule,
    fleetAlerts: fleetAlertsModule,
    notifications: notificationsModule,
    kDiagram: kdiagramCalculateModule,
    vesselInformation: vesselInformationModule,
    windGlobalModule,
    weatherRelativeWindDataModule,
    cii: ciiModule,
    fleet: fleetModule,
    signals,
    alarms,
  }
});
